import { createStore } from "vuex";
import { event } from "vue-gtag";
export default createStore({
  state: {
    analyticsToolName: "Ball Splines Special Machining",
    host: window.thomsonSettings & window.thomsonSettings.name ? window.thomsonSettings.name : "Thomson"
  },
  mutations: {
  },
  actions: {

    trackEvent(context, { action, label = null, value = null }) {
      let hostname = process.env.VUE_APP_TYPE === "distributor" ? ' - ' + window.location.hostname : '';
      if (process.env.VUE_APP_TRACKING_ENABLED == 'true') {
        event(action, {
          "event_category": context.state.analyticsToolName + " - " + context.state.host + hostname,
          "event_label": label,
          "value": value
        });
      }
      else { 
        // eslint-disable-next-line
        console.log("%cTracking Event:", "background:#41b883; padding:1px 3px; border-radius:3px; color:#fff", { action: action, event_category: context.state.analyticsToolName + " - " + context.state.host + hostname, event_label: label, value: value });
      }
    },

  },
  modules: {
  }
})
